<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Lieferantengruppe bearbeiten') }}</h1>
        </div>

        <p>
            <a :href="supplierGroup.permalink" target="_blank">{{ supplierGroup.permalink }}</a>
        </p>

        <div class="">
            <form @submit.prevent="form.put(route('admin.supplier-groups.update', supplierGroup))">
                <form-fields :form="form" :supplierGroup="supplierGroup" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'supplierGroup',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: this.supplierGroup.name,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>